import {
  CheckCircleOutlined,
  StopOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import { Tag } from "antd";
import * as APITypes from "~/API";
import { useTranslation } from "react-i18next";

export const PaymentStatusTag = ({
  status,
}: {
  status: APITypes.PaymentStatusType;
}) => {
  const { t } = useTranslation();
  let color = "grey";
  let icon = <SyncOutlined />;
  let statusText = t(status as any);

  if (status === APITypes.PaymentStatusType.Complete) {
    color = "green";
    icon = <CheckCircleOutlined />;
  }
  if (status === APITypes.PaymentStatusType.Failed) {
    color = "red";
    icon = <StopOutlined />;
  }
  if (status === APITypes.PaymentStatusType.Processing) {
    color = "blue";
    icon = <SyncOutlined />;
  }
  return (
    <Tag color={color} icon={icon}>
      {statusText}
    </Tag>
  );
};
